import React from 'react';
import { Check } from 'lucide-react';

const STEPS = ['المكان', 'الأبعاد', 'الإضاءة الحالية', 'النتائج'];

export default function InspectProgress({ currentStep }: { currentStep: number }) {
  return (
    <div className="mb-10">
      <div className="flex items-center justify-between mb-4">
        {STEPS.map((label, index) => {
          const stepNum = index + 1;
          const isDone = stepNum < currentStep;
          const isActive = stepNum === currentStep;

          return (
            <React.Fragment key={`inspect-step-${stepNum}`}>
              <div className="flex flex-col items-center gap-2">
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm transition-all duration-300 ${
                    isDone ? 'bg-success text-white' : isActive ? 'gradient-dark text-white' : 'bg-muted text-muted-foreground'
                  }`}
                >
                  {isDone ? <Check size={16} /> : stepNum}
                </div>
                <span className={`text-xs font-semibold hidden sm:block ${isActive ? 'text-secondary' : isDone ? 'text-success' : 'text-muted-foreground'}`}>
                  {label}
                </span>
              </div>
              {index < STEPS.length - 1 && (
                <div className="flex-1 mx-2 h-0.5 relative">
                  <div className="absolute inset-0 bg-muted rounded-full" />
                  <div
                    className="absolute inset-0 bg-secondary rounded-full transition-all duration-500"
                    style={{ width: stepNum < currentStep ? '100%' : '0%' }}
                  />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
      <div className="progress-bar">
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{
            width: `${((currentStep - 1) / 3) * 100}%`,
            background: 'linear-gradient(90deg, #3F4044, #202124)',
          }}
        />
      </div>
    </div>
  );
}